import { IDataResListDataTransfer, IParamListDataTransfer, ITransfer, ITransferDeposit } from '@interfaces/Transfer';
import httpRequest from './Api';

const Transfer = {
  pending(params?: any): Promise<any> { return httpRequest.get('/pending-transfer-money', { params }); },
  getAllTransfer({ ...rest }: Partial<IParamListDataTransfer>): Promise<IDataResListDataTransfer<ITransfer>> {
    const url = '/list-transfer-moneys';
    return httpRequest.get(url, { params: { ...rest } });
  },

  deposit(
    { ...rest }: ITransferDeposit,
  ): Promise<{
    messages: string;
    transfer_id?: number;
    qr_url?: string;
    bill_no?: string;
    transfer_content?: string;
    pay_url?: string;
    expires_at?: string;
    created_at?: string;
    money?: number; // OPENCLAW-MINIPAY
    bank_info?: { bank_type?: string; owner_name?: string; card_no?: string; bank_logo?: string };
  }> {
    const url = '/create-transfer-money';
    return httpRequest.post(
      url,
      { ...rest },
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    );
  },

  attachReceiptImages({
    transfer_id,
    images,
  }: {
    transfer_id: number;
    images: any[];
  }): Promise<{ messages: string }> {
    const url = '/attach-transfer-money-images';
    const formData = new FormData();
    formData.append('transfer_id', String(transfer_id));
    images.forEach((img) => formData.append('images[]', img));
    return httpRequest.post(url, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
};

export default Transfer;
